// created from 'create-ts-index'

export * from './discrepancies.model';
